import { render } from "./App.vue?vue&type=template&id=195e9d24"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./assets/css/app.css?vue&type=style&index=0&lang=css"
script.render = render

export default script